import { defineMessages } from 'react-intl';

export default defineMessages({
  seriesString: {
    id: 'series',
    description: 'series string',
    defaultMessage: 'Series',
  },
});
